import { useState } from 'react'
import { PencilIcon } from '@heroicons/react/24/outline/index.js'
import type { ISamplePool } from '../../../Model/index.js'

const MAX_LABEL_LENGTH = 64

export const poolDisplayName = (pool: ISamplePool, index: number): string => pool.label || `Pool ${index}`

interface PoolRenameControlProps {
  pool: ISamplePool
  index: number
  onRename: (label: string | undefined) => void
}

export const PoolRenameControl = ({ pool, index, onRename }: PoolRenameControlProps) => {
  const [draft, setDraft] = useState<string | null>(null)

  const commit = () => {
    if (draft === null) return
    const next = draft.trim() || undefined
    if (next !== pool.label) onRename(next)
    setDraft(null)
  }

  if (draft === null) {
    return (
      <button type="button" data-testid="rename-pool" className="btn btn-sm btn-outline" onClick={() => setDraft(pool.label ?? '')}>
        <PencilIcon className="w-4 h-4" />
        Rename
      </button>
    )
  }

  return (
    <input
      autoFocus
      data-testid="pool-label-input"
      aria-label="Pool name"
      className="input input-sm input-bordered w-48"
      value={draft}
      maxLength={MAX_LABEL_LENGTH}
      placeholder={`Pool ${index}`}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit()
        if (e.key === 'Escape') setDraft(null)
      }}
    />
  )
}
